var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

import React from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';

import { Label } from 'sdc-i18n-react';
import { indexShowing } from 'sdc-cms-client';
import { HelpIcon } from 'sdc-cms-help';
import { MarkdownPanel } from 'sdc-markdown-viewer';

export var FieldLabel = (_dec = inject('helpStore', 'typesStore'), _dec(_class = observer(_class = (_class2 = function (_React$Component) {
  _inherits(FieldLabel, _React$Component);

  function FieldLabel() {
    var _temp, _this, _ret;

    _classCallCheck(this, FieldLabel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initDefineProp(_this, 'showHelp', _descriptor, _this), _initDefineProp(_this, 'toggle', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  FieldLabel.prototype.render = function render() {
    var typeName = this.props.typesStore.typesByID[this.props.field.typeID].name;
    var key = this.props.field.name || (typeName || 'type').toLowerCase() + '.' + this.props.field.key;
    return React.createElement(
      'label',
      { className: 'col-form-label ' + (indexShowing.showing ? 'col-md-2' : 'col-md-3'), style: this.props.labelStyle },
      React.createElement(Label, { value: key }),
      ' ',
      this.props.field.localize && React.createElement(
        'span',
        { className: 'language' },
        '(',
        this.props.locale.name,
        ')'
      ),
      React.createElement(HelpIcon, { topic: key, onClick: this.toggle }),
      this.showHelp && React.createElement(
        'div',
        { className: 'form-label-help' },
        React.createElement(MarkdownPanel, { ignoreIndex: true, text: this.props.helpStore.helpTextFor(key) })
      )
    );
  };

  return FieldLabel;
}(React.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'showHelp', [observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'toggle', [action], {
  enumerable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function () {
      _this2.showHelp = !_this2.showHelp;
    };
  }
})), _class2)) || _class) || _class);